export default {
    cma: 'CMA Report',
    soi: 'Statement of Information Report',
    rental: ' Rental CMA Report',
};